import { useQuery } from '@tanstack/react-query';
import { api, type VideoRecord } from '../lib/api';

function fmtDate(ms: number | undefined): string {
  if (!ms) return '—';
  return new Date(ms).toLocaleDateString();
}

export function LibraryPage() {
  const videosQuery = useQuery({
    queryKey: ['videos', 'published'],
    queryFn: () => api.listVideosByStatus('published'),
    refetchInterval: 30_000,
  });

  return (
    <div>
      <h2 className="text-3xl font-bold mb-2">Library</h2>
      <p className="text-parchment-700 mb-8">
        Published videos. Click any to open on YouTube. Analytics ingestion ships
        in a follow-up (deferred tech debt).
      </p>

      {videosQuery.isLoading && (
        <p className="text-sm font-mono text-parchment-700">loading…</p>
      )}
      {videosQuery.isError && (
        <p className="text-sm font-mono text-red-700">api unreachable</p>
      )}
      {videosQuery.data && videosQuery.data.items.length === 0 && (
        <div className="card-neumorphic text-center text-parchment-700 py-12">
          <p className="font-mono text-sm">no videos published yet</p>
          <p className="text-xs mt-2">first publish will appear here</p>
        </div>
      )}
      {videosQuery.data && videosQuery.data.items.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {videosQuery.data.items.map((v: VideoRecord) => {
            const url = v.youtube_url ?? (v.youtube_video_id
              ? `https://youtube.com/watch?v=${v.youtube_video_id}`
              : null);
            return (
              <a
                key={v.video_id}
                href={url ?? '#'}
                target="_blank"
                rel="noreferrer"
                className="card-neumorphic !p-0 overflow-hidden block hover:shadow-neumorphic-md transition-shadow"
              >
                {/* Thumbnail (uses any thumbnail_keys image presigned by getVideo, or first one) */}
                <div className="bg-parchment-200 aspect-video flex items-center justify-center">
                  <p className="font-mono text-xs text-parchment-700">
                    {v.youtube_video_id ?? v.video_id.slice(0, 12)}
                  </p>
                </div>
                <div className="p-4">
                  <p className="font-medium text-sm line-clamp-2">
                    {v.selected_title ?? v.title_options?.[0] ?? '(untitled)'}
                  </p>
                  <p className="text-xs font-mono text-parchment-700 mt-2">
                    {fmtDate(v.updated_at ?? v.created_at)}
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}
